/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type LocationFilter_root$ref: FragmentReference;
declare export opaque type LocationFilter_root$fragmentType: LocationFilter_root$ref;
export type LocationFilter_root = {|
  +developmentProductInfo: {|
    +states: $ReadOnlyArray<?{|
      +state: ?string,
      +developmentsCount: ?number,
    |}>
  |},
  +$refType: LocationFilter_root$ref,
|};
export type LocationFilter_root$data = LocationFilter_root;
export type LocationFilter_root$key = {
  +$data?: LocationFilter_root$data,
  +$fragmentRefs: LocationFilter_root$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LocationFilter_root",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "DevelopmentProductInfo",
      "kind": "LinkedField",
      "name": "developmentProductInfo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "DevelopmentState",
          "kind": "LinkedField",
          "name": "states",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "state",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "developmentsCount",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = 'f8d35d32330ab99752f5ef560bb47c41';

export default node;
